export const common = {
  nav: {
    home: '首頁',
    about: '關於我們',
    products: '產品',
    services: '服務',
    cases: '案例',
    contact: '聯絡',
    consultation: '免費諮詢'
  },
  hero: {
    badge: 'JS Glass Corporation | Milgard & JELD-WEN 認證經銷商 | 30 年卓越經驗',
    title1: '專業玻璃與',
    title2: '門窗解決方案',
    subtitle: 'JS Glass Corporation - Milgard Windows & JELD-WEN 認證經銷商，擁有 30 年經驗，提供客製化玻璃製作、門窗安裝與維修服務',
    cta1: '免費諮詢',
    cta2: '查看產品'
  },
  about: {
    badge: '關於我們',
    title: '關於我們',
    subtitle: '成立於 2000 年，JS Glass 是一家家族經營的門窗公司',
    description: 'JS Glass 銷售高品質的門窗，以及各種玻璃產品，如衣櫃門、浴室淋浴門和玻璃本身。我們盡最大努力為您找到適合您需求的高品質產品。我們在同類產品上提供極具競爭力的價格。無論您是更換房屋的門窗還是建造新結構，我們都致力於通過優質的產品和卓越的服務，為客戶提供最佳的整體價值方案。',
    feature1Title: '家族企業',
    feature1Desc: '成立於 2000 年，擁有專業的銷售團隊和超過 25 年經驗的安裝人員',
    feature2Title: '優質產品',
    feature2Desc: '提供適合您需求的高品質門窗和玻璃產品',
    feature3Title: '競爭力價格',
    feature3Desc: '極具競爭力的價格，提供最佳的整體價值方案',
    stat1: '服務年資',
    stat2: '完成項目',
    stat3: '客戶滿意度'
  },
  products: {
    badge: '產品',
    title: '優質門窗產品',
    subtitle: 'Milgard 和 JELD-WEN 授權經銷商，提供多樣化門窗選擇，滿足不同需求和風格',
    viewDetails: '查看詳情',
    product1: '乙烯基窗戶',
    product1Desc: '耐用、節能、低維護的乙烯基窗戶系列',
    product2: '鋁製窗戶',
    product2Desc: '現代設計、堅固耐用的鋁製窗戶',
    product3: '滑動門',
    product3Desc: '大面積玻璃設計，提供廣闊視野',
    product4: '法式門',
    product4Desc: '優雅設計，提升家居美感',
    product5: 'JS Glass 淋浴門',
    product5Desc: '客製化 JS Glass 淋浴門系統，30 年工藝卓越，多種風格選擇',
    product6: '木製門窗',
    product6Desc: 'JELD-WEN 經典木製門窗，自然質感與優越隔音',
    product7: '玻璃纖維入口門',
    product7Desc: 'JELD-WEN 玻璃纖維入口門，耐候性強且工藝精美',
    product8: '商業玻璃',
    product8Desc: '商業空間玻璃解決方案'
  },
  services: {
    badge: '服務',
    title: '全面服務解決方案',
    subtitle: '從諮詢、測量、設計到安裝，我們提供一站式專業服務，讓您的門窗升級無憂',
    service1: '免費諮詢',
    service1Desc: '一對一專業諮詢，根據您的需求提供最合適的門窗解決方案',
    service2: '現場測量',
    service2Desc: '專業團隊提供免費現場精確測量，確保尺寸完美契合您的空間',
    service3: '設計方案',
    service3Desc: '客製化門窗設計方案，3D 預覽，讓您提前看到安裝效果',
    service4: '專業安裝',
    service4Desc: '擁有 30 年專業經驗的安裝團隊，嚴格遵循標準程序，確保安裝品質',
    service5: '品質保固',
    service5Desc: '全面的售後保固服務，讓您使用無憂',
    ctaBadge: '聯絡我們',
    ctaTitle1: '立即預約',
    ctaTitle2: '免費現場',
    ctaTitle3: '測量服務',
    ctaHeading1: '專業團隊',
    ctaHeading2: '為您服務',
    ctaDesc: '我們的專業團隊擁有超過 30 年的門窗安裝經驗。從初步諮詢到最終安裝，我們全程提供貼心服務。立即預約，享受免費現場測量服務，讓我們為您打造理想的生活空間。',
    ctaButton: '立即預約'
  },
  cases: {
    badge: '案例分享',
    title: '成功案例',
    subtitle: '查看我們為客戶完成的優質項目，見證專業品質與服務',
    case1: '現代住宅窗戶更換',
    case1Desc: '全屋 Milgard 乙烯基窗戶更換，提升能源效率',
    case2: '商業建築玻璃幕牆',
    case2Desc: '大型商業項目玻璃幕牆安裝',
    case3: '豪華別墅滑動門',
    case3Desc: '客製化大型滑動門系統安裝',
    case4: 'JS Glass 浴室淋浴門翻新',
    case4Desc: '現代風格 JS Glass 淋浴門系統升級，優質工藝',
    case5: '辦公室玻璃隔間',
    case5Desc: '商業空間玻璃隔間設計與安裝',
    case6: '陽光房建造',
    case6Desc: '客製化陽光房玻璃結構項目'
  },
  contact: {
    badge: '聯絡我們',
    title: '聯絡我們',
    subtitle: '歡迎來電或填寫表單，我們將盡快回覆您的詢問',
    formTitle: '發送訊息',
    formSubtitle: '填寫下方表單，我們將盡快與您聯繫',
    name: '姓名',
    email: '電子郵件',
    phone: '電話',
    message: '訊息',
    send: '發送訊息',
    sending: '發送中...',
    success: '訊息發送成功！',
    error: '發送失敗，請稍後再試',
    infoTitle: '聯絡資訊',
    address: '地址',
    addressValue: '12211 Garvey Ave, El Monte, CA 91732',
    phoneValue: '(626) 443-2688',
    emailValue: 'info@jsglass.com',
    hours: '營業時間',
    hoursValue: '週一至週五：上午 9:30 - 下午 5:00',
    hoursClosed: '週末休息'
  },
  footer: {
    description: 'JS Glass Corporation 是擁有 30 年經驗的 Milgard Windows & JELD-WEN 認證經銷商，提供專業玻璃與門窗解決方案。',
    quickLinks: '快速連結',
    services: '服務',
    service1: '門窗安裝',
    service2: '玻璃更換',
    service3: 'JS Glass 淋浴門系統',
    service4: '商業玻璃',
    contact: '聯絡',
    rights: '版權所有',
    poweredBy: '網站建置'
  },
  vinylWindows: {
    badge: '優質乙烯基窗戶',
    heroTitle: 'Milgard 乙烯基窗戶',
    heroSubtitle: '節能、低維護的乙烯基窗戶，專為持久美觀和性能而設計',
    ctaButton: '獲取免費報價',
    overviewTitle: '為什麼選擇乙烯基窗戶',
    overviewDesc: 'Milgard 乙烯基窗戶結合了卓越的能源效率和永恆的美學。採用先進材料和精密工藝製造，我們的乙烯基窗戶提供卓越的性能，同時只需最少的維護。',
    feature1: '節能高效',
    feature1Desc: '先進的隔熱技術降低能源成本',
    feature2: '低維護',
    feature2Desc: '無需油漆，易於清潔和維護',
    feature3: '耐用結構',
    feature3Desc: '專為抵禦惡劣天氣條件而設計',
    feature4: '終身保固',
    feature4Desc: '業界領先的保固覆蓋範圍',
    stylesTitle: '可選窗戶樣式',
    stylesSubtitle: '選擇多種樣式以匹配您家的建築風格',
    style1: '雙懸窗',
    style1Desc: '經典設計，兩個窗扇均可操作，便於清潔',
    style2: '平開窗',
    style2Desc: '側鉸鏈窗戶向外開啟，提供最大通風',
    style3: '推拉窗',
    style3Desc: '平滑的水平操作，適合寬開口',
    style4: '固定窗',
    style4Desc: '固定窗戶，最大化視野和自然光',
    style5: '凸窗和弓形窗',
    style5Desc: '優雅的突出窗戶，為任何房間增添層次感',
    style6: '遮陽窗',
    style6Desc: '頂部鉸鏈窗戶，即使在雨天也能完美通風',
    galleryTitle: '乙烯基窗戶畫廊',
    gallerySubtitle: '探索我們在美麗家居中安裝的優質 Milgard 乙烯基窗戶系列',
    benefitsTitle: '主要優勢',
    benefit1: '節能省電',
    benefit1Desc: '多腔室設計和 Low-E 玻璃降低供暖和製冷成本',
    benefit2: '降噪',
    benefit2Desc: '卓越的隔音效果，最大限度地減少外部噪音，打造更安靜的家',
    benefit3: '紫外線防護',
    benefit3Desc: '阻擋有害紫外線，保護您的家具和地板',
    benefit4: '經濟實惠',
    benefit4Desc: '卓越的價值，長期節省維護和能源成本',
    benefit5: '設計靈活',
    benefit5Desc: '提供多種顏色和飾面，匹配任何裝飾風格',
    benefit6: '環保',
    benefit6Desc: '可回收材料和能源效率減少環境影響',
    glassTitle: '玻璃選項',
    glassSubtitle: '使用先進的玻璃技術定制您的窗戶',
    glass1: 'Low-E 玻璃',
    glass1Desc: '反射熱量，同時允許自然光通過',
    glass2: '鋼化玻璃',
    glass2Desc: '增強安全玻璃，強度是標準玻璃的 4-5 倍',
    glass3: '夾層玻璃',
    glass3Desc: '通過中間層保護增加安全性和隔音效果',
    glass4: '磨砂玻璃',
    glass4Desc: '適用於浴室和其他私密空間的隱私玻璃選項',
    warrantyTitle: '業界領先的保固',
    warrantyDesc: 'Milgard 乙烯基窗戶享有全面的終身保固，涵蓋玻璃破損、紗窗缺陷和五金件。我們對產品充滿信心，確保您的投資在未來多年得到保護。',
    ctaTitle: '準備升級您的窗戶了嗎？',
    ctaDesc: '立即聯繫我們進行免費諮詢和報價。我們的專家將幫助您為家選擇完美的乙烯基窗戶。'
  },
  aluminumWindows: {
    badge: '現代鋁製窗戶',
    heroTitle: 'Milgard 鋁製窗戶',
    heroSubtitle: '時尚耐用的鋁製窗戶，具有現代設計和卓越強度',
    ctaButton: '獲取免費報價',
    overviewTitle: '為什麼選擇鋁製窗戶',
    overviewDesc: 'Milgard 鋁製窗戶提供無與倫比的強度和現代美學。憑藉纖細的型材和寬敞的玻璃區域，鋁製窗戶在保持結構完整性和能源效率的同時，提供最大的自然光。',
    feature1: '現代設計',
    feature1Desc: '時尚的型材和簡潔的線條，適合現代建築',
    feature2: '纖細框架',
    feature2Desc: '窄框架最大化玻璃面積和自然光',
    feature3: '卓越強度',
    feature3Desc: '鋁製結構提供卓越的耐用性',
    feature4: '終身保固',
    feature4Desc: '全面的保固覆蓋，讓您安心',
    stylesTitle: '可選窗戶樣式',
    stylesSubtitle: '適合各種建築需求的現代鋁製窗戶樣式',
    style1: '推拉窗',
    style1Desc: '平滑的水平操作，維護最少',
    style2: '單懸窗',
    style2Desc: '經典風格，底部窗扇可操作',
    style3: '固定窗',
    style3Desc: '固定窗戶，提供無阻礙的視野',
    style4: '平開窗',
    style4Desc: '側鉸鏈，提供出色的通風控制',
    style5: '遮陽窗',
    style5Desc: '頂部鉸鏈設計，適合通風',
    style6: '建築窗',
    style6Desc: '定制形狀和配置，適合獨特設計',
    galleryTitle: '鋁製窗戶畫廊',
    gallerySubtitle: '探索我們在現代家居中的優質 Milgard 鋁製窗戶',
    benefitsTitle: '主要優勢',
    benefit1: '卓越耐用性',
    benefit1Desc: '鋁材抗翹曲、開裂和腐蝕',
    benefit2: '最大採光',
    benefit2Desc: '纖細的框架允許更大的玻璃面積和更多的自然光',
    benefit3: '顏色選項',
    benefit3Desc: '提供多種飾面，包括陽極氧化和粉末塗層',
    benefit4: '可回收',
    benefit4Desc: '環保且完全可回收的材料',
    benefit5: '防火',
    benefit5Desc: '不可燃材料提供額外的安全性',
    benefit6: '低維護',
    benefit6Desc: '易於清潔，需要最少的維護',
    ctaTitle: '準備安裝現代鋁製窗戶了嗎？',
    ctaDesc: '立即聯繫我們進行免費諮詢。我們的團隊將幫助您為現代家居選擇完美的鋁製窗戶。'
  },
  slidingDoors: {
    badge: '優質滑動門',
    heroTitle: 'Milgard 滑動門',
    heroSubtitle: '寬敞的玻璃滑動門，無縫連接室內外生活空間',
    ctaButton: '獲取免費報價',
    overviewTitle: '為什麼選擇滑動門',
    overviewDesc: 'Milgard 滑動門結合了優雅的設計、平滑的操作和能源效率。憑藉大型玻璃面板和耐用的結構，我們的滑動門在您的家和戶外空間之間創造無縫過渡。',
    feature1: '廣闊視野',
    feature1Desc: '大型玻璃面板最大化自然光和戶外視野',
    feature2: '平滑操作',
    feature2Desc: '優質滾輪確保輕鬆的滑動動作',
    feature3: '安全設計',
    feature3Desc: '多點鎖定系統提供增強的安全性',
    feature4: '終身保固',
    feature4Desc: '所有組件的全面保固覆蓋',
    stylesTitle: '可選門樣式',
    stylesSubtitle: '選擇各種配置以適合您的空間',
    style1: '雙面板',
    style1Desc: '經典設計，一個固定面板和一個滑動面板',
    style2: '三面板',
    style2Desc: '更寬的開口，多種面板配置',
    style3: '四面板',
    style3Desc: '最大開口寬度，適合寬敞空間',
    style4: '隱藏門',
    style4Desc: '面板滑入牆腔，提供無阻礙的開口',
    style5: '提升滑動門',
    style5Desc: '優質系統，大型面板輕鬆操作',
    style6: '多滑動門',
    style6Desc: '多個面板堆疊，完全打開牆壁',
    galleryTitle: '滑動門畫廊',
    gallerySubtitle: '探索我們在美麗家居中的優質 Milgard 滑動門系列',
    benefitsTitle: '主要優勢',
    benefit1: '全景視野',
    benefit1Desc: '大型玻璃區域提供無阻礙的戶外視野',
    benefit2: '節省空間',
    benefit2Desc: '無需擺動半徑，適合狹小空間',
    benefit3: '節能高效',
    benefit3Desc: '先進的密封條和 Low-E 玻璃降低能源成本',
    benefit4: '自然光',
    benefit4Desc: '最大化日光，照亮您的生活空間',
    benefit5: '增強安全性',
    benefit5Desc: '多點鎖和加固框架確保安全',
    benefit6: '易於維護',
    benefit6Desc: '易於清潔和維護，持久性能',
    ctaTitle: '準備改造您的空間了嗎？',
    ctaDesc: '立即聯繫我們進行免費諮詢。我們的專家將幫助您選擇完美的滑動門，連接您的室內外生活區域。'
  },
  frenchDoors: {
    hero: {
      title: '法式門',
      subtitle: '優雅設計與永恆之美的完美結合',
      cta: '獲取免費報價'
    },
    overview: {
      title: '為您的家增添經典優雅',
      description: '法式門為任何空間帶來永恆的精緻感和自然光線。憑藉其獨特的玻璃面板和優雅設計，它們在室內外生活之間創造無縫連接，同時為您的家增添建築美感。',
      feature1: {
        title: '經典設計',
        description: '永不過時的多玻璃面板經典風格'
      },
      feature2: {
        title: '自然採光',
        description: '通過整扇門的大面積玻璃面板最大化陽光'
      },
      feature3: {
        title: '多樣選擇',
        description: '提供各種材料、飾面和配置選項'
      },
      feature4: {
        title: '室內外通用',
        description: '適用於露台、陽台或室內房間隔斷'
      }
    },
    styles: {
      title: '法式門款式',
      subtitle: '從我們的優雅法式門系列中選擇',
      style1: {
        title: '傳統法式門',
        description: '經典鉸鏈雙門，帶有分隔玻璃面板和裝飾格柵，展現永恆優雅'
      },
      style2: {
        title: '現代法式門',
        description: '現代設計，線條簡潔，框架極簡，玻璃面板大而無遮擋'
      },
      style3: {
        title: '帶側窗的法式門',
        description: '增強入口，一側或兩側配有匹配玻璃面板，增加光線和對稱性'
      },
      style4: {
        title: '滑動法式門',
        description: '節省空間的設計，將法式門美學與滑動功能完美結合'
      },
      style5: {
        title: '帶氣窗的法式門',
        description: '高雅設計，門上方配有裝飾玻璃面板，增加高度和光線'
      },
      style6: {
        title: '室內法式門',
        description: '完美的房間隔斷，在定義獨立生活空間的同時保持開放感'
      }
    },
    gallery: {
      title: '法式門畫廊',
      subtitle: '探索我們精美的法式門安裝案例'
    },
    benefits: {
      title: '為什麼選擇法式門',
      subtitle: '發現在家中安裝法式門的優勢',
      benefit1: {
        title: '建築美感',
        description: '為任何房間或入口增添永恆優雅和精緻風格'
      },
      benefit2: {
        title: '充足自然光',
        description: '大面積玻璃面板讓空間充滿陽光，營造通透氛圍'
      },
      benefit3: {
        title: '室內外連接',
        description: '無縫融合室內外空間，提升生活體驗'
      },
      benefit4: {
        title: '增加房產價值',
        description: '法式門是理想的特色，可以提升您的房產價值'
      },
      benefit5: {
        title: '靈活配置',
        description: '提供各種尺寸、材料和開啟方式，滿足您的需求'
      },
      benefit6: {
        title: '節能選項',
        description: '現代法式門配備優質玻璃和密封條，有助於保持舒適溫度'
      }
    },
    cta: {
      title: '準備好安裝法式門了嗎？',
      description: '立即聯繫我們，獲取免費諮詢和法式門安裝報價',
      button: '立即聯繫我們'
    }
  },
  showerDoors: {
    hero: {
      title: 'JS Glass 淋浴门',
      subtitle: '定制玻璃解决方案，打造完美浴室空间',
      cta: '获取免费报价'
    },
    overview: {
      title: '高端淋浴门解决方案',
      description: '使用我们的定制淋浴门提升您的浴室品质。从无框玻璃到半无框设计，我们提供高品质解决方案，将功能性与惊艳美学完美结合，打造您理想的淋浴空间。',
      feature1: {
        title: '优质玻璃',
        description: '高品质钢化安全玻璃，耐用且清晰透明'
      },
      feature2: {
        title: '定制尺寸',
        description: '精确测量，完全贴合您的浴室规格'
      },
      feature3: {
        title: '优质五金',
        description: '耐用的铰链、把手和密封条，多种饰面可选'
      },
      feature4: {
        title: '易于维护',
        description: '光滑表面和保护涂层，清洁轻松无忧'
      }
    },
    styles: {
      title: '淋浴门款式',
      subtitle: '探索我们的淋浴门设计系列，匹配您的浴室风格',
      style1: {
        title: '无框玻璃门',
        description: '时尚现代设计，五金件极简，呈现干净开放的外观和最大采光'
      },
      style2: {
        title: '半无框门',
        description: '平衡设计，细微框架提供稳定性，同时保持现代美学'
      },
      style3: {
        title: '滑动淋浴门',
        description: '节省空间的解决方案，滑动面板顺畅，适合小型浴室'
      },
      style4: {
        title: '旋转淋浴门',
        description: '经典摆动设计，优雅铰链，适合较宽的淋浴开口'
      },
      style5: {
        title: '钻石角门',
        description: '转角安装设计，最大化紧凑浴室的空间效率'
      },
      style6: {
        title: '步入式淋浴面板',
        description: '开放式概念设计，固定玻璃面板，打造奢华水疗般的体验'
      }
    },
    gallery: {
      title: '淋浴门展示',
      subtitle: '查看我们的定制淋浴门安装案例'
    },
    benefits: {
      title: '为什么选择我们的淋浴门',
      subtitle: '体验优质淋浴门安装的优势',
      benefit1: {
        title: '现代美学',
        description: '时尚现代玻璃改造您的浴室，提升任何设计风格'
      },
      benefit2: {
        title: '安全第一',
        description: '所有玻璃均经过钢化处理，确保最大安全性，符合行业标准'
      },
      benefit3: {
        title: '防水密封',
        description: '精密密封和专业安装，防止漏水和水损害'
      },
      benefit4: {
        title: '耐用性强',
        description: '优质材料和五金件确保持久性能和可靠性'
      },
      benefit5: {
        title: '定制解决方案',
        description: '每扇淋浴门都专门为您的空间测量和制作'
      },
      benefit6: {
        title: '专业安装',
        description: '专家安装确保完美贴合、功能和饰面'
      }
    },
    cta: {
      title: '准备升级您的浴室了吗？',
      description: '立即联系我们，获取定制淋浴门的免费咨询和报价',
      button: '立即联系我们'
    }
  },
  woodWindows: {
    hero: {
      title: 'JELD-WEN 木制门窗',
      subtitle: '经典美学与自然温暖，卓越性能的完美结合',
      cta: '获取免费报价'
    },
    overview: {
      title: '木材的永恒优雅',
      description: 'JELD-WEN 木制门窗为您的家带来自然美感和温暖。采用优质材料精心制作，我们的木制产品提供卓越的隔热性能、真实的质感和持久的价值。',
      feature1: {
        title: '自然美感',
        description: '真实的木纹纹理为任何空间增添温暖和特色'
      },
      feature2: {
        title: '卓越隔热',
        description: '天然木材提供出色的热性能和能源效率'
      },
      feature3: {
        title: '可定制饰面',
        description: '可染色或涂漆，匹配您独特的风格和装饰偏好'
      },
      feature4: {
        title: '优质工艺',
        description: 'JELD-WEN 品质结构确保耐用性和持久性能'
      }
    },
    styles: {
      title: '木制门窗款式',
      subtitle: '探索我们的经典木制产品系列',
      style1: {
        title: '双悬木窗',
        description: '传统风格，两扇窗扇均可操作，具有真实的分格和经典比例'
      },
      style2: {
        title: '平开木窗',
        description: '侧铰链设计，优雅五金件，提供出色的通风和无遮挡视野'
      },
      style3: {
        title: '木制入口门',
        description: '宏伟的入口门，丰富的木纹，装饰玻璃选项，令人印象深刻的外观吸引力'
      },
      style4: {
        title: '木制法式门',
        description: '经典优雅，多个玻璃面板，适合露台和室内空间'
      },
      style5: {
        title: '凸窗和弓形木窗',
        description: '建筑美学，扩展生活空间，让房间充满自然光'
      },
      style6: {
        title: '定制木制造型',
        description: '特殊形状包括拱形、圆形和几何设计，打造独特的建筑风格'
      }
    },
    gallery: {
      title: '木制门窗展示',
      subtitle: '探索 JELD-WEN 木制产品的永恒之美'
    },
    benefits: {
      title: '为什么选择木制门窗',
      subtitle: '体验真实木制产品的优势',
      benefit1: {
        title: '天然隔热',
        description: '木材天然隔热性能优于乙烯基或铝材，降低能源成本'
      },
      benefit2: {
        title: '真实质感',
        description: '真实的木纹图案创造无法复制的温暖和优雅'
      },
      benefit3: {
        title: '设计多样性',
        description: '可染色、涂漆或饰面，完美匹配您家的风格和配色方案'
      },
      benefit4: {
        title: '隔音效果',
        description: '卓越的声学性能减少外部噪音，打造更安静的家'
      },
      benefit5: {
        title: '提升房产价值',
        description: '优质木制产品提升房产价值，吸引挑剔的买家'
      },
      benefit6: {
        title: '可持续选择',
        description: '负责任采购的木材是可再生、环保的建筑材料'
      }
    },
    cta: {
      title: '准备体验经典木质之美了吗？',
      description: '立即联系我们，获取 JELD-WEN 木制门窗的免费咨询',
      button: '立即联系我们'
    }
  },
  fiberglassDoors: {
    hero: {
      title: 'JELD-WEN 玻璃纤维入口门',
      subtitle: '惊艳美感与无与伦比的耐用性和性能',
      cta: '获取免费报价'
    },
    overview: {
      title: '完美的入口门解决方案',
      description: 'JELD-WEN 玻璃纤维入口门将木材的真实外观与卓越的耐用性和低维护性完美结合。经过工程设计，可承受恶劣天气，同时保持美观，这些门提供卓越的能源效率和持久价值。',
      feature1: {
        title: '木纹真实感',
        description: '真实的木材纹理，外观和触感如同真木，无需维护'
      },
      feature2: {
        title: '耐候性强',
        description: '即使在极端温度和湿度条件下也不会翘曲、开裂或腐烂'
      },
      feature3: {
        title: '节能高效',
        description: '卓越的隔热性能降低能源成本，提高家居舒适度'
      },
      feature4: {
        title: '低维护',
        description: '耐用饰面抗褪色，多年来只需最少的维护'
      }
    },
    styles: {
      title: '玻璃纤维门款式',
      subtitle: '从我们丰富的入口门设计系列中选择',
      style1: {
        title: '传统面板门',
        description: '经典凸起面板设计，真实木纹纹理，打造永恒的外观吸引力'
      },
      style2: {
        title: '工匠风格门',
        description: '艺术与工艺风格设计，线条简洁，装饰玻璃选项'
      },
      style3: {
        title: '现代简约门',
        description: '时尚简约设计，光滑表面和几何玻璃图案'
      },
      style4: {
        title: '乡村做旧门',
        description: '纹理饰面复制陈年木材，适合农舍和乡村家居风格'
      },
      style5: {
        title: '玻璃面板入口门',
        description: '优雅设计，装饰玻璃嵌件，增强自然采光'
      },
      style6: {
        title: '双开入口门',
        description: '宏伟的入口系统，匹配的双门对，打造令人印象深刻的入口'
      }
    },
    gallery: {
      title: '玻璃纤维入口门展示',
      subtitle: '探索我们美丽的 JELD-WEN 玻璃纤维门系列'
    },
    benefits: {
      title: '为什么选择玻璃纤维入口门',
      subtitle: '探索优质玻璃纤维结构的优势',
      benefit1: {
        title: '卓越耐用性',
        description: '比木门或钢门更能抵抗凹痕、划痕和损坏'
      },
      benefit2: {
        title: '全天候性能',
        description: '在极端高温、寒冷和湿度下保持完整性和外观'
      },
      benefit3: {
        title: '增强安全性',
        description: '坚固结构配备多点锁定系统，让您安心无忧'
      },
      benefit4: {
        title: '节能省钱',
        description: '出色的隔热性能全年降低供暖和制冷成本'
      },
      benefit5: {
        title: '真实外观',
        description: '逼真的木纹纹理可染色以匹配任何木材种类'
      },
      benefit6: {
        title: '长期价值',
        description: '最少的维护和持久的美观提供出色的投资回报'
      }
    },
    cta: {
      title: '准备升级您的入口了吗？',
      description: '立即联系我们，获取 JELD-WEN 玻璃纤维入口门的免费咨询',
      button: '立即联系我们'
    }
  },
  commercialGlass: {
    badge: '商业玻璃解決方案',
    heroTitle: '商業玻璃系統',
    heroSubtitle: '為現代商業空間和建築提供專業玻璃解決方案',
    ctaButton: '獲取免費報價',
    overviewTitle: '為什麼選擇商業玻璃',
    overviewDesc: '我們的商業玻璃解決方案為企業提供現代美學、節能和耐用性。從店面到辦公室隔斷，我們提供專業安裝，提升您的商業空間，同時符合建築規範和安全標準。',
    feature1: '現代設計',
    feature1Desc: '時尚的玻璃系統打造專業、現代的空間',
    feature2: '安全合規',
    feature2Desc: '所有安裝均符合商業建築規範和安全要求',
    feature3: '節能高效',
    feature3Desc: '先進的玻璃技術降低能源成本，提高舒適度',
    feature4: '專業安裝',
    feature4Desc: '由經驗豐富的商業玻璃專家進行專業安裝',
    stylesTitle: '商業玻璃應用',
    stylesSubtitle: '滿足各種商業需求的全面玻璃解決方案',
    style1: '幕牆系統',
    style1Desc: '現代商業建築的落地玻璃外牆',
    style2: '店面玻璃',
    style2Desc: '具有大型展示窗和門的吸引人零售入口',
    style3: '玻璃隔斷',
    style3Desc: '辦公室內部玻璃牆，創造開放但明確的空間',
    style4: '商業門',
    style4Desc: '商業入口的自動和手動玻璃門系統',
    style5: '玻璃欄杆',
    style5Desc: '陽台和樓梯的無框玻璃欄杆系統',
    style6: '玻璃雨棚',
    style6Desc: '建築入口的結構玻璃雨棚和遮陽篷',
    galleryTitle: '商業玻璃畫廊',
    gallerySubtitle: '查看我們的專業商業玻璃安裝案例',
    benefitsTitle: '主要優勢',
    benefit1: '自然採光',
    benefit1Desc: '最大化日光，創造明亮、高效的工作環境',
    benefit2: '專業外觀',
    benefit2Desc: '現代玻璃系統提升您的企業形象和品牌',
    benefit3: '能源性能',
    benefit3Desc: '高性能玻璃降低空調成本，提高效率',
    benefit4: '耐用性',
    benefit4Desc: '商業級材料，經得起頻繁使用',
    benefit5: '成本效益',
    benefit5Desc: '維護需求最少，長期價值高',
    benefit6: '專業支持',
    benefit6Desc: '專業諮詢、安裝和持續服務',
    ctaTitle: '準備好您的商業玻璃項目了嗎？',
    ctaDesc: '立即聯繫我們，獲取商業玻璃解決方案的免費諮詢和報價。'
  }
};